(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('IntrumentoRelacionadoDetailController', IntrumentoRelacionadoDetailController);

    IntrumentoRelacionadoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'IntrumentoRelacionado', 'Norma'];

    function IntrumentoRelacionadoDetailController($scope, $rootScope, $stateParams, previousState, entity, IntrumentoRelacionado, Norma) {
        var vm = this;

        vm.intrumentoRelacionado = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:intrumentoRelacionadoUpdate', function(event, result) {
            vm.intrumentoRelacionado = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
